import { render, staticRenderFns } from "./sdxText.vue?vue&type=template&id=cb0b1ef4&scoped=true"
import script from "./sdxText.vue?vue&type=script&lang=js"
export * from "./sdxText.vue?vue&type=script&lang=js"
import style0 from "./sdxText.vue?vue&type=style&index=0&id=cb0b1ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0b1ef4",
  null
  
)

export default component.exports